module.exports = __webpack_public_path__ + "static/media/histogram_chart.1c2ff984.svg";